import React from 'react';
import { Box } from '@mui/material';

interface FormContainerProps {
  /**
   * Form content to display
   */
  children: React.ReactNode;
  /**
   * Maximum width of the form container
   * @default 500
   */
  maxWidth?: number;
}

/**
 * Molecule: Simple wrapper for form content
 * Provides consistent padding and max-width for readability
 * Clean, flat design with no card styling
 */
export const FormContainer: React.FC<FormContainerProps> = ({
  children,
  maxWidth = 500,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: `${maxWidth}px`,
        px: { xs: 3, sm: 4 },
        py: 4,
      }}
    >
      {children}
    </Box>
  );
};
